/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FacialFrontal/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function FacialFrontal({
  children,
  viewPath = "/DesignSystem/Images/FacialFrontal",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 197,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 386
  
}) {
  return (<React.Fragment
>
<img
  data-testid="FacialFrontal.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-Oc89d': alignSelf,'--bc-2-Oc89d': backgroundColor,'--bblr-3-Oc89d': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Oc89d': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Oc89d': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Oc89d': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Oc89d': typeof height === 'number' ? `${height}px` : height,'--mb-8-Oc89d': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Oc89d': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Oc89d': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Oc89d': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-Oc89d': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}